export const muiOutlinedInputRoot = () => ({
    padding: "unset",
    "& .MuiOutlinedInput-input": {
        padding: "14px 8px 14px 16px"
    },
    "& .MuiInputBase-inputSizeSmall": {
        padding: "10px 8px 10px 16px"
    }
});
//# sourceMappingURL=input.config.js.map